(function () {
  // Beamish add-ons. Bound once on document. After any cart write we do a full page
  // load (no hand-swapped drawer HTML), so no scroll lock, overlay or focus trap is left behind.
  if (window.__bmwUpsells) return; window.__bmwUpsells = true;
  var busy = false;
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }
  function reload() { window.location.reload(); }
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bmw-add]'); if (!b) return;
    e.preventDefault(); if (busy) return; busy = true;
    b.disabled = true; b.setAttribute('aria-busy', 'true');
    post('/cart/add.js', { items: [{ id: Number(b.getAttribute('data-bmw-add')), quantity: 1 }] }).then(reload, reload);
  });

  // Swap Package Protection tier when subtotal crosses $100. Max 2 tries per page session per cart line, so it can never loop.
  function checkSwap() {
    var s = document.querySelector('[data-bmw-swap]'); if (!s || busy) return;
    var k = 'bmwSwap:' + s.getAttribute('data-key') + '>' + s.getAttribute('data-id');
    var n = Number(sessionStorage.getItem(k) || 0); if (n >= 2) return;
    sessionStorage.setItem(k, n + 1); busy = true;
    post('/cart/change.js', { id: s.getAttribute('data-key'), quantity: 0 })
      .then(function () { return post('/cart/add.js', { items: [{ id: Number(s.getAttribute('data-id')), quantity: 1 }] }); })
      .then(reload, function () { busy = false; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkSwap); else checkSwap();
  // Theme quantity edits re-render the cart without reloading; re-check after those (one-shot, no observer).
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(checkSwap, 400); });
  }

})();
